export default "__VITE_ASSET__mCmeTWBA__"